import React, { useState } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { Modal, Button, Row, Col, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import { images } from '../../config/images'
import './SubscriptionAlertAfterLogin.scss'
import { routes } from '../../routes'
function SubscriptionAlertAfterLogin(props) {
  const {
    indexKey = 0,
    visible = false,
    modalTitle = '',
    iconURL = '',
    infoTitle = 'Info',
    bodyContent = 'Please contact Administrator for further help.',
    buttonText = 'Ok',
    toNavigate = '',
  } = props
  const [isVisible, setIsVisible] = useState(visible)
  const { onSetClose = () => {} } = props

  const { permissionStore = {} } = props || {}
  const { currentOrg = undefined, usage } = permissionStore || {}

  const redirect = async () => {
    await onSetClose(false)
    setIsVisible(false)
    return props.history.push(
      routes.confirmandpay.generateRoute(
        currentOrg?.currentPlanId,
        usage?.userCount?.limit,
        currentOrg?.id,
        true
      ),
      { redirected: true }
    )
  }

  return (
    <div className="SubscriptionAlertAfterLoginStyles">
      <Modal
        title={modalTitle || ''}
        className="subscriptioninfo"
        visible={isVisible}
        onOk={() => {
          onSetClose(false)
          setIsVisible(false)
        }}
        onCancel={() => {
          onSetClose(false)
          setIsVisible(false)
        }}
        destroyOnClose={true}
        footer={false}
        key={indexKey}
      >
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <div className="info-image">
              <img src={iconURL ? iconURL : images.infoSub} alt="" />
            </div>
          </Col>
        </Row>
        <Row gutter={[0, 10]}>
          <Col span={24}>
            <h3>{infoTitle}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: bodyContent || '',
              }}
            ></p>
            <Space>
              {toNavigate ? (
                <Button type="primary" size="large" onClick={() => redirect()}>
                  Renew Plan
                </Button>
              ) : (
                <Button
                  type="primary"
                  size="large"
                  onClick={() => {
                    onSetClose(false)
                    setIsVisible(false)
                  }}
                >
                  {buttonText}
                </Button>
              )}
            </Space>
          </Col>
        </Row>
      </Modal>
    </div>
  )
}

export default withRouter(
  inject('loginStore', 'permissionStore')(observer(SubscriptionAlertAfterLogin))
)
